import React, { useEffect } from "react";
import PublicNavigation from "../../components/universal/public-navigation";
import ArticleLayout from "../../components/universal/article-layout";
import PrivacyPolicyContent from "../../components/public/privacy-policy";
import PublicFooter from "../../components/universal/public-footer";
import AOS from "aos";
import { Helmet } from "react-helmet-async";
import "aos/dist/aos.css";

const PrivacyPolicyPage = () => {
  useEffect(() => {
    AOS.init();
  }, []);

  return (
    <>
      <Helmet>
        <title>Leadfind - Personvern</title>
        <meta name="thumbnail" content="https://leadfind.no/showcase.jpg" />
        <meta name="robots" content="index, follow" />
        <meta
          name="description"
          content="Les om hvordan Leadfind behandler dine personopplysninger, hvorfor vi gjør det og hvordan vi bruker denne informasjonen."
        />
        <meta name="author" content="Leadfind" />
        <meta
          name="keywords"
          content="prospecting, salgsverktøy, salg, nye kunder, crm"
        />

        <meta name="twitter:card" content="summary" />
        <meta name="twitter:url" content="https://leadfind.no/personvern" />
        <meta name="twitter:title" content="Leadfind - Personvern" />
        <meta
          name="twitter:description"
          content="Les om hvordan Leadfind behandler dine personopplysninger, hvorfor vi gjør det og hvordan vi bruker denne informasjonen."
        />
        <meta name="twitter:image" content="https://leadfind.no/showcase.jpg" />

        <meta property="og:url" content="https://leadfind.no/personvern" />
        <meta property="og:type" content="article" />
        <meta property="og:title" content="Leadfind - Personvern" />
        <meta
          property="og:description"
          content="Les om hvordan Leadfind behandler dine personopplysninger, hvorfor vi gjør det og hvordan vi bruker denne informasjonen."
        />
        <meta property="og:image" content="https://leadfind.no/showcase.jpg" />
        <link rel="canonical" href="https://leadfind.no/personvern" />
      </Helmet>
      <ArticleLayout
        Header={() => <PublicNavigation light={true} />}
        Content={() => <PrivacyPolicyContent />}
        Footer={() => <PublicFooter />}
      />
    </>
  );
};

export default PrivacyPolicyPage;
